import React from "react";
import "./CardGrid.scss";
import { Card } from "..";

interface CardGridProps {
  events: {
    image: string;
    eyebrow: string;
    title: string;
    date: string;
    location: { city: string; region: string; regionLink: string };
    summary: string;
    url?: string;
    hide_media: boolean;
  }[];
}

export const CardGrid: React.FC<CardGridProps> = ({ events }) => {
  if (!events || events.length === 0) {
    return (
      <div className="card-grid card-grid--no-events">
        <p className="utility-lg">Oops, it looks like there are no events for the filters you've selected. Adjust your filters or clear them to see events!</p>
      </div>
    );
  }

  return (
    <div className="card-grid">
      {events.map((event, index) => (
        <Card key={event.url || index} {...event} />
      ))}
    </div>
  );
};
